export const moment = require('moment')
//require('moment/locale/es')

moment.updateLocale('es', {
  relativeTime : {
      future: "en %s",
      past:   "hace %s",
      s  : '%d seg',
      ss : '%d seg',
      m:  "1 min",
      mm: "%d min",
      h:  "1 hora",
      hh: "%d hrs",
      d:  "un día",
      dd: "%d días",
      w:  "una semana",
      ww: "%d semanas",
      M:  "un mes",
      MM: "%d meses",
      y:  "un año",
      yy: "%d años"
  }
});

moment.humanizeDuration = function(eventDuration, full) {
  var eventMDuration = moment.duration(eventDuration, 'milliseconds');
  var eventDurationString = ""
  var truncate = false;
  if (eventMDuration.months() > 0){
      eventDurationString += " " + moment.duration(eventMDuration.months(), 'months').humanize()
      truncate = true;
  }
  if (eventMDuration.days() > 0){
      eventDurationString += truncate ? ", " : " " 
      eventDurationString += moment.duration(eventMDuration.days(), 'days').humanize()
      if(truncate && !full) return eventDurationString.trim()
      truncate = true;
  }
  if (eventMDuration.days() > 7 && eventMDuration.days()%7 > 1){ //Si hay remanente de dias de semanas o meses
      eventDurationString += truncate ? ", " : " " 
      eventDurationString += moment.duration(eventMDuration.days()%7, 'days').humanize()
      if(truncate && !full) return eventDurationString.trim()
      truncate = true;
  }
  if (eventMDuration.hours() > 0){
      eventDurationString += truncate ? ", " : " " 
      eventDurationString += " " + moment.duration(eventMDuration.hours(), 'hours').humanize()
      if(truncate && !full) return eventDurationString.trim()
      truncate = true;
  }
  if (eventMDuration.minutes() > 0){
      eventDurationString += truncate ? ", " : " " 
      eventDurationString += " " + moment.duration(eventMDuration.minutes(), 'minutes').humanize()
      if(truncate && !full) return eventDurationString.trim()
      truncate = true;
  }
  if (eventMDuration.seconds() > 0){
      eventDurationString += truncate ? ", " : " " 
      eventDurationString += " " + moment.duration(eventMDuration.seconds(), 'seconds').humanize()
      if(truncate && !full) return eventDurationString.trim()
      truncate = true;
  }

  return eventDurationString.trim()
}